import { createFileRoute } from '@tanstack/react-router'
import { LandingRedirectContent } from 'pages/redirects/LandingRedirectContent'

export const Route = createFileRoute('/landing')({
  component: RouteComponent,
  staticData: {
    title: 'Landing',
  },
})

function RouteComponent() {
  return <LandingRedirectContent />
}
